import { render } from "./MappingTable.vue?vue&type=template&id=21d2a2a8"
import script from "./MappingTable.vue?vue&type=script&lang=js"
export * from "./MappingTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__